import LineGraph from "./components/line-graph";
import {useNavigate, useNavigation, useParams} from "react-router-dom";
import axiosInstance from "../../../../API/Axios/AxiosConfig";
import URLS from "../../../../API/Axios/URLS";
import {useEffect, useState} from "react";
import useForm from "../../../../hooks/useForm";
import PracticePageFilter from "../../practice/variables/PracticePageFilter";
import Filter from "../../practice/component/Filter";
import getPracticeAnalysisFilter from "./variables/anaylsis-filter";

export default function PracticeAnalysis({className, ...props}) {
    const {type} = useParams();
    const [graphData, setGraphData] = useState({
        average: [],
        questionNumber: [],
        scores: []
    })
    const [form, error, loading, setFormData, actions] = useForm({
        prType: type
    })
    const navigate = useNavigate();

    function fetchGraphData() {
        actions.post(URLS.analysis, (data) => {
            return {
                prType: type
            }
        }).then(response => {
            setGraphData(response?.data)
        })
    }

    useEffect(() => {
        fetchGraphData()
    }, [type]);

    return (
        <div className={` ${className} flex justify-center items-center`}>
            <div
                className={"w-full lg:w-[80%] 3xl:w-[50%] p-4 pt-20 gap-[0.75rem]  flex flex-col justify-center items-center"}>
                <p className={"font-bold text-3xl"}>
                    Practice Analysis
                </p>

                <div className={"rounded-md w-full bg-white flex flex-col gap-[1rem] mt-[0.75rem] shadow-md p-8"}>
                    <div className={"flex flex-row-reverse w-full"}>
                        <Filter
                            currentValue={type}
                            className={"items-end"}
                            select={(value) => {
                                navigate(`/tools/practice-analysis/${value.type}`)
                            }}
                            {...getPracticeAnalysisFilter()}


                        />
                    </div>
                    <LineGraph graphData={graphData} loading={loading}/>
                </div>

            </div>
        </div>

    )
}